{
  "welcome": "Willkommen bei AirPlx {{email}}!",
  "errorTitle": "Wir konnten dich nicht anmelden.",
  "errorMessage": "Klicke auf die Schaltfläche unten, um es erneut zu versuchen. Falls das Problem weiterhin besteht, kontaktiere bitte support@airplx.com."
}
